import { Drawer } from "@mui/material";
import { useDispatch } from "react-redux";
import KwilLogo from "../assets/KwilDB.svg";
import FundingPoolList from "./nav-components/FundingPoolList";
import MoatList from "./nav-components/MoatList";
import SchemaList from "./nav-components/SchemaList";
import { Scrollbars } from 'react-custom-scrollbars-2';

export default function NavBar({ initialTable, initialSchema, update, setUpdate, initialPools, privKey, secret}) {
    
    return(
        <Drawer
            variant="persistent"
            anchor="left"
            open={true}
            sx={{
                display: "flex",
                flexDirection: "column",
                "& .MuiDrawer-paper": {
                  maxHeight: "100vh",
                  maxWidth: "275px",
                  borderRight: "2px solid #323232",
                  background:
                    "linear-gradient(270deg, #0E5AC4 -25.27%, rgba(28, 64, 124, 0) 132.55%);)",
                  backgroundColor: "#000",
                  padding: "0px 7px",
                }
            }}
        >
            <img 
                src={KwilLogo}
                alt="logo"
                className="logo"
            />
            <MoatList 
                privKey={privKey}
                secret={secret}
            />
            <Scrollbars>
                <SchemaList
                    privKey={privKey}
                    secret={secret}
                    initialTable={initialTable}
                    initialSchema={initialSchema}
                    update={update}
                    setUpdate={setUpdate}
                />
                <FundingPoolList
                    privKey={privKey}
                    initialPools={initialPools}
                />
            </Scrollbars>
        </Drawer>
    )
}